module.exports = __webpack_public_path__ + "static/media/mob-new-cover.c228fe7b.png";